import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TPostGenerateEmployeeIDUploadLinkPrivateRequest,
  TPostGenerateEmployeeIDUploadLinkPrivateResponse,
} from "./postGenerateEmployeeIDUploadLinkPrivate.schema";

export const postGenerateEmployeeIDUploadLinkPrivate = (
  axios: IAxiosInstance
) => {
  return async (
    params: TPostGenerateEmployeeIDUploadLinkPrivateRequest
  ): Promise<string> => {
    const response =
      await axios.noRetry.post<TPostGenerateEmployeeIDUploadLinkPrivateResponse>(
        `/api/employees/id_upload_link`,
        params
      );

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Failed to generate employee document upload link");
  };
};
